( function( $ ) {
    "use strict";

    var RemindAlerts = {};

    RemindAlerts.onClickDelete = function() {
        var $button = $(this),
            $remindAlertsContainer = $button.closest('[data-remindalerts]'),
            $remindAlerts = $remindAlertsContainer.find('[data-remindalert]'),
            $remindAlert = $button.closest('[data-remindalert]'),
            $remindAlertId = $remindAlert.data('remindalert');

        if (! confirm($remindAlert.data('confirm'))) {
            return false;
        }

        $button.prop('disabled', true);
        $remindAlert.toggleClass('hidden', true);
        if ($remindAlerts.filter(':visible').length === 0) {
            $remindAlertsContainer.toggleClass('hidden', true);
        }

        function revert() {
            $remindAlert.toggleClass('hidden', false);
            $button.prop('disabled', false);
            $remindAlertsContainer.toggleClass('hidden', false);
        }

        $.App.api('DELETE', 'remind-alerts/'+$remindAlertId)
            .done(function (data, textStatus) {
                if (textStatus !== 'nocontent') {
                    revert();
                }
            })
            .fail(revert);
    };

    RemindAlerts.onClickNew = function() {
        var $button = $(this),
            $form = $('form[data-new-remindalert="'+$button.attr('target')+'"]');


        $form.toggleClass('hidden', false);
        $form.find(':input:visible').first().trigger('focus');
    };

    RemindAlerts.onClickCancel = function () {
        var $form = $(this).closest('[data-new-remindalert]');

        $form.toggleClass('hidden', true);
    };

    RemindAlerts.onSubmit = function () {
        var $form = $(this),
            formData = $form.serializeArray(),
            followUpId = $form.find('[data-form-control="remindalertable_id"]').val();

        if ($form.data('remind-alerts.state')) {
            return false;
        }

        $form.data('remind-alerts.state', 'loading').addClass('ajax-loading');
        $form.find(':input').prop('disabled', true);

        $.App.api('POST', 'follow-ups/'+followUpId+'/remind-alerts', formData)
            .done(function (response) {
                if (! response.success) {
                    return false;
                }

                window.location.ajax(window.location.href);
            })
            .always(function () {
                $form.removeClass('ajax-loading').data('remind-alerts.state', null);
                $form.find(':input').prop('disabled', false)
            });
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $deleteRemindAlertButton = $container.find('[data-remindalert] [role="delete-remindalert"]'),
            $newRemindAlertButton = $container.find('[role="new-remindalert"]'),
            $form = $container.find('[data-new-remindalert]'),
            $cancel = $form.find('[data-form-cancel]');

        $deleteRemindAlertButton.on('click.remindalerts', RemindAlerts.onClickDelete);
        $newRemindAlertButton.on('click.remindalerts', RemindAlerts.onClickNew);
        $cancel.on('click.remindalerts', RemindAlerts.onClickCancel);
        $form.on('submit.remindalerts', RemindAlerts.onSubmit);
    });

} ( require('jquery') ) );
